module.exports = __webpack_public_path__ + "static/media/22_BOJO_MEIA_TACA_ESTAMPADO_01.67d405ae.jpg";